import _ from 'lodash';
import {
  HandlingRequestStatus,
  HandlingRequestType,
  StockLotCRUDSchema,
} from 'types/inventory';

export const isFirstCheckQuant = (stockLot: StockLotCRUDSchema) =>
  _.get(stockLot, 'handlingRequests', []).filter(
    (hr) =>
      hr.requestType === HandlingRequestType.CHECK_QUANT &&
      hr.status === HandlingRequestStatus.COMPLETE
  ).length === 0;

export const isReceivedFromIngest = (stockLot: StockLotCRUDSchema) =>
  stockLot.receivedFromIngest && isFirstCheckQuant(stockLot);

export const isReceivedFromPurchaseLine = (stockLot: StockLotCRUDSchema) =>
  !!stockLot.purchaseLineQuant && isFirstCheckQuant(stockLot);

const HANDLING_REQUEST_TYPES_FOR_VALIDATION = [
  HandlingRequestType.SPLICE,
  HandlingRequestType.COMBINE,
  HandlingRequestType.REEL,
  HandlingRequestType.SPLIT,
  HandlingRequestType.REPACKAGE,
];

export const getHandlingRequestInfo = (stockLot: StockLotCRUDSchema) => {
  const lastCompletedHandlingRequest = _.chain(stockLot)
    .get('handlingRequests', [])
    .filter((hr) => hr.status === HandlingRequestStatus.COMPLETE)
    .sortBy('completedAt')
    .last()
    .value();

  const isFromHandlingRequest =
    !!lastCompletedHandlingRequest &&
    _.includes(
      HANDLING_REQUEST_TYPES_FOR_VALIDATION,
      lastCompletedHandlingRequest.requestType
    );

  const handlingRequestType = isFromHandlingRequest
    ? lastCompletedHandlingRequest.requestTypeDisplay
    : '';

  return {
    isFromHandlingRequest,
    handlingRequestType,
  };
};
